import React from 'react';

// import { Container } from './styles';

export default function Profile() {
  return (
    <div />
  );
}
